import { DayTrade } from './pages/home-logged/screens/courses/day_trade/day-trade.component';
import { ProfitPro } from './pages/home-logged/screens/courses/profit-pro/profit-pro.component';
import { Routes } from '@angular/router';

import { MetaTagType } from '@toro/common/shared/enum/seo/meta-tag-type.enum';

import { WithdrawalHistoryPageComponent } from './pages/draft/withdrawal-history/withdrawal-history-page.component';

import { DraftComponent } from './pages/draft/draft/draft.component';
import { TransferComponent } from './pages/transfer/transfer.component';
import { DraftErrorComponent } from './pages/draft/drafterror/drafterror.component';
import { AgreementComponent } from './pages/agreement/agreement.component';
import { CustomPlanComponent } from './pages/onboarding/custom-plan/custom-plan.component';
import { HomeLoggedShellComponent } from './pages/home-logged/home-logged-shell/home-logged-shell.component';
import { CustomWalletBuilderComponent } from './pages/onboarding/custom-wallet-builder/custom-wallet-builder.component';
import { ThankYouPageComponent } from './pages/home-logged/screens/thank-you-page/thank-you-page.component';
import { ProfitToroTrader } from './pages/home-logged/screens/courses/profit-toro-trader/profit-toro-trader.component';
import { OpenedAccountTraderComponent } from './pages/home-logged/screens/opened-account-trader/opened-account-trader.component';
import { environment } from '../environments/environment';


export const routes: Routes = [
    {
        path: 'patrimonio',
        pathMatch: 'full',
        redirectTo: '',
    },
    {
        path: '',
        component: HomeLoggedShellComponent,
        // canActivate: [AuthGuard],
    },
    {
        path: 'transferencia',
        component: TransferComponent
    },
    {
        path: 'minha-carteira',
        loadChildren: () => import('./shared/modules/customer-wallet/customer-wallet.routes').then(m => m.CustomerWalletRoutesModule),
    },
    {
        path: 'saque',
        component: DraftComponent,
        children: [
            { path: 'erro', component: DraftErrorComponent },
            {
                path: ':bancos',
                component: DraftComponent,
                children: [
                    // { path: 'sucesso', component: DraftSuccessComponent },
                    { path: 'erro', component: DraftErrorComponent }
                ],
                data: {
                    metaData: {
                        title: `Saque - Banco | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" }`,
                        metaTags: [
                            {
                                name: MetaTagType.Description,
                                content:
                                    'Qual valor deseja sacar? Transfira seus recursos para o banco'
                            }
                        ]
                    }
                }
            }
        ],
        data: {
            metaData: {
                title: `Saque | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" }`,
                metaTags: [
                    {
                        name: MetaTagType.Description,
                        content:
                            'Qual valor deseja sacar? Transfira seus recursos'
                    }
                ]
            }
        }
    },
    {
        path: 'monte-seu-plano-de-investimentos',
        component: CustomWalletBuilderComponent
    },
    {
        path: 'saques-recentes',
        component: WithdrawalHistoryPageComponent
    },
    {
        path: 'meu-plano-de-investimentos/:planSlug',
        component: CustomPlanComponent
    },
    {
        path: 'agreement',
        component: AgreementComponent,
        data: {
            metaData: {
                title: `Agrement | ${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" }`,
            }
        }
    },
    {
        path: 'boas-vindas-trader',
        component: ThankYouPageComponent
    },
    {
        path: 'lp-toro-trader',
        component: ProfitToroTrader
    },
    {
        path: 'lp-profit-pro',
        component: ProfitPro,
    },
    {
        path: 'lp-curso-daytrade-iniciantes',
        component: DayTrade,
    },
    {
        path: 'conta-aberta-trader',
        component: OpenedAccountTraderComponent
    },
];
